import { useQuery } from "@tanstack/react-query";

import { companyQuery } from "#modules/company/infra/company.query";

export const useCompany = () => {
  const { data: company, ...rest } = useQuery({
    ...companyQuery(),
  });

  return { company, ...rest };
};
